import { removeAllStorage } from 'app/utils/utils';
import axios from 'axios';

/**
 * Configura interceptores globales de axios para la aplicacion
 *
 * Request Interceptor:
 * - Inyecta token de autenticacion en headers Authorization
 * - Configura baseURL desde configuracion de entorno
 *
 * Response Interceptor:
 * - Maneja errores 403 (unauthorized) redirigiendo a login
 * - Distingue entre requests canceladas y errores reales
 * - Retorna estructura consistente { error } para manejo de errores
 * - Retorna { error: null, cancelled: true } para cancelaciones
 *
 * @param {Object} axiosInstance - Instancia de axios
 * @param {string} baseUrl - URL base de la API
 * @param {Object} store - Redux store para acceder a authToken
 */
export function setupAxios(axiosInstance, baseUrl, store) {
  axiosInstance.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `${authToken}`;
      }

      config.baseURL = baseUrl;
      return config;
    },
    (err) => Promise.reject(err)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 403) {
        removeAllStorage();
        window.location.href = '/auth/login';
        return;
      }

      if (axios.isCancel(error)) {
        return {
          error: null,
          cancelled: true,
          message: error.message || 'Request cancelled',
        };
      }

      return {
        error: error.response || error,
      };
    }
  );
}
